import HeroMedia from "./components/HeroMedia";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <HeroMedia />
      </div>
    </div>
  );
};

export default Tables;
